import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { ChapterList } from "components/TrainingContent/Chapter/ChapterList"
import { CreateChapterDialog } from "components/TrainingContent/Chapter/CreateChapterDialog"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import trainingModuleService from "services/trainingModuleService"
import { setCurrentTrainingModule } from "slices/trainingModuleSlice"

export function TrainingModule() {
  const currentTrainingModule = useAppSelector(
    (state) => state.trainingmodule.currentTrainingModule,
  )
  const { id } = useParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (currentTrainingModule !== undefined) {
      return
    }

    if (id === undefined) {
      return
    }

    trainingModuleService
      .getTrainingModule(id)
      .then((trainingModule) => {
        dispatch(setCurrentTrainingModule(trainingModule))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [currentTrainingModule, dispatch, id])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>{currentTrainingModule?.name}</Title>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>CHAPTERS</Title>
            </Grid>
            <Grid item>
              <CreateChapterDialog />
            </Grid>
          </Grid>
          {currentTrainingModule && <ChapterList trainingModule={currentTrainingModule} />}
        </Paper>
      </Grid>
    </Grid>
  )
}
